import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const curriculumData = [
  {
    id: "1",
    title: "자존감학과",
    label: "MIND",
    description: "자기 가치 점검과 상처 회복",
    color: "#0D5F5E",
    image: "https://images.unsplash.com/photo-1635607596286-cf52df4b912d?w=400&h=300&fit=crop",
  },
  {
    id: "2",
    title: "소통기술학과",
    label: "SKILL",
    description: "호감형 대화법과 카톡 훈련",
    color: "#8B4541",
    image: "https://images.unsplash.com/photo-1604881991405-b273c7a4386a?w=400&h=300&fit=crop",
  },
  {
    id: "3",
    title: "여성학과",
    label: "FOR HER",
    description: "맞춤 연애 팁과 매력 발산",
    color: "#7B8DB8",
    image: "https://images.pexels.com/photos/10265201/pexels-photo-10265201.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
  },
  {
    id: "4",
    title: "남성학과",
    label: "FOR HIM",
    description: "연애 팁과 매너, 리더십",
    color: "#2C4A5E",
    image: "https://images.unsplash.com/photo-1650036517860-620ab8a9af0f?w=400&h=300&fit=crop",
  },
  {
    id: "5",
    title: "연애학과",
    label: "LOVE",
    description: "설렘부터 고백까지 A to Z",
    color: "#C4956A",
    image: "https://images.unsplash.com/photo-1649389457678-11c7dd5bc85a?w=400&h=300&fit=crop",
  },
  {
    id: "6",
    title: "매력학과",
    label: "CHARM",
    description: "외면·내면 매력 업그레이드",
    color: "#6B4C6E",
    image: "https://images.unsplash.com/photo-1762342695113-0ab0918b6f3b?w=400&h=300&fit=crop",
  },
  {
    id: "7",
    title: "사랑학과",
    label: "HEART",
    description: "진정한 사랑의 기술",
    color: "#3A6B5E",
    image: "https://images.unsplash.com/photo-1695645233313-3b1c7b825973?w=400&h=300&fit=crop",
  },
  {
    id: "8",
    title: "갈등학과",
    label: "HEAL",
    description: "관계 회복과 소통의 기술",
    color: "#8B6B4A",
    image: "https://images.unsplash.com/photo-1575752002196-782497f1c0c4?w=400&h=300&fit=crop",
  },
  {
    id: "9",
    title: "이혼 치유학과",
    label: "RESTART",
    description: "아픔을 딛고 새 출발",
    color: "#5E4A6B",
    image: "https://images.unsplash.com/photo-1662466818280-5f5155cbf559?w=400&h=300&fit=crop",
  },
  {
    id: "10",
    title: "사별 회복학과",
    label: "RECOVER",
    description: "상실감 극복과 재시작",
    color: "#4A6B7B",
    image: "https://images.unsplash.com/photo-1562263055-38a8df587f69?w=400&h=300&fit=crop",
  },
  {
    id: "11",
    title: "결혼학과",
    label: "MARRIAGE",
    description: "행복한 결혼을 위한 준비",
    color: "#6B5E4A",
    image: "https://images.unsplash.com/photo-1769374072073-bc358149ecee?w=400&h=300&fit=crop",
  },
  {
    id: "12",
    title: "중년성학과",
    label: "INTIMACY",
    description: "친밀감과 깊은 교감",
    color: "#8B7B8B",
    image: "https://images.unsplash.com/photo-1684613876886-d194b8feb903?w=400&h=300&fit=crop",
  },
];

export const CurriculumSection = () => {
  const navigate = useNavigate();
  const [isPaused, setIsPaused] = useState(false);

  const handleViewDetail = (curriculumId) => {
    navigate(`/curriculum/${curriculumId}`);
  };

  // 카드를 두 번 복제하여 무한 스크롤 효과
  const duplicatedData = [...curriculumData, ...curriculumData];

  return (
    <section
      id="curriculum"
      className="pt-10 pb-6 lg:pt-14 lg:pb-8 bg-[#f5f0e8] relative overflow-hidden"
      data-testid="curriculum-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-6">
          <span className="text-gold-500 font-medium text-sm tracking-wider uppercase mb-4 block">
            Curriculum
          </span>
          <h2 className="font-sans text-3xl md:text-4xl font-[720] text-stone-800 mb-4">
            연애사관학교
          </h2>
          <p className="text-stone-500 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            연애는 막연한 예감이 아닌, 마음을 읽는 정교한 배움에서 시작됩니다.<br />
            시행착오의 시간을 줄이고, 당신의 사랑이 머물러야 할 확실한 이정표를 제시합니다.<br /><br />
            나를 투영하고 상대를 깊이 수용하는 관계의 미학—<br />
            찰나의 설렘을 넘어, 시간이 흐를수록 깊어지는 사랑의 기술을 전합니다.
          </p>
        </div>
      </div>

      {/* Marquee Slider - 화면 전체 너비 사용 */}
      <div 
        className="relative w-full overflow-hidden"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* CSS Animation Style */}
        <style>{`
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .marquee-track {
            animation: marquee 60s linear infinite;
          }
          .marquee-track.paused {
            animation-play-state: paused;
          }
        `}</style>

        {/* Marquee Track */}
        <div 
          className={`flex gap-5 marquee-track ${isPaused ? 'paused' : ''}`}
          style={{ width: 'fit-content' }}
        >
          {duplicatedData.map((item, index) => (
            <div
              key={`card-${index}`}
              onClick={() => handleViewDetail(item.id)}
              className="rounded-2xl overflow-hidden flex flex-col transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 cursor-pointer flex-shrink-0 group"
              style={{ 
                width: '260px',
                height: '380px',
                backgroundColor: item.color,
              }}
              data-testid={`curriculum-card-${index}`}
            >
              {/* Top - Text area */}
              <div className="p-5 flex-shrink-0">
                <span className="text-white/40 text-base md:text-lg tracking-[0.15em] uppercase font-semibold block">{item.label}</span>
                <h3 className="text-white font-bold text-lg md:text-xl mt-2 leading-tight">{item.title}</h3>
                <p className="text-white/60 text-xs mt-2 leading-relaxed">{item.description}</p>
              </div>
              {/* Bottom - Image area with arrow */}
              <div className="flex-1 relative overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity"
                />
                <div className="absolute bottom-4 right-4 w-9 h-9 rounded-full border border-white/50 flex items-center justify-center bg-black/20 group-hover:bg-white/20 transition-colors">
                  <ArrowRight className="w-4 h-4 text-white" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        {/* Total Count */}
        <p className="text-center text-stone-500 text-sm mt-8">
          총 {curriculumData.length}개 학과 운영 중
        </p>
      </div>
    </section>
  );
};
